import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bestie_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export function captureAffiliate() {
  const p = new URLSearchParams(window.location.search);
  const ref = p.get("via") || p.get("ref") || p.get("promotekit_referral") || p.get("aff");
  if (ref) localStorage.setItem("bestie_ref", ref);
}

export const getAffiliate = () => localStorage.getItem("bestie_ref") || null;

export const TYPE_LABELS: Record<string, string> = {
  value: "Teach / value", story: "Story", sell: "Sell", nurture: "Nurture", announce: "Announce", reconnect: "Reconnect",
  celebrate: "Celebrate a win", last_chance: "Last chance", event: "Event / webinar", follow_up: "Follow up", pick_for_me: "Pick for me",
};

export const TYPE_COLORS: Record<string, string> = {
  value: "bg-olive-light text-olive-deep", story: "bg-[#E5E8A7] text-[#687000]", sell: "bg-navy text-cream", nurture: "bg-sand text-ink-muted",
  announce: "bg-[#E5E8A7] text-[#071D2B]", reconnect: "bg-[#E5E8A7] text-[#071D2B]", celebrate: "bg-[#E5E8A7] text-[#687000]",
  last_chance: "bg-clay text-navy", event: "bg-[#E5E8A7] text-[#687000]", follow_up: "bg-sand text-ink-muted",
};

export const fmtDate = (s?: string | null, opts: Intl.DateTimeFormatOptions = { weekday: "short", month: "short", day: "numeric" }) =>
  s ? new Date(s.length === 10 ? s + "T12:00:00" : s).toLocaleDateString(undefined, opts) : "";

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const addDays = (iso: string, n: number) => { const d = new Date(iso + "T12:00:00"); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
